export default __webpack_public_path__ + "static/media/verified-icon-black.f89fc842.svg";